import { createSlice } from '@reduxjs/toolkit';

const roundSpecialSlice = createSlice({
  name: 'roundSpecials',
  initialState : {
    rounds: [],
    lastRoundId: null,
    lastDate: null,
    roundDetails: null,
    roundTimeline: [],
    roundCornerTimeline: [],
    selectedMarketOddsHistory: [],
    oddsDetails: [],
    marketsDisplayed: {},
    roundSpecialOddsHistoryTemplate: []
  },
  reducers: {
    aGetRoundSpecialRoundsAction: () => {},
    aGetRoundSpecialRoundsSuccessAction: (state, action) => {
      state.rounds = action.payload.rounds;
      state.lastRoundId = action.payload.lastRoundId;
      state.lastDate = action.payload.lastDate;
    },
    aGetRoundSpecialRoundsFailAction: () => {},
    aClearRoundSpecialsState: (state) => {
      state.rounds = [];
      state.lastRoundId = null;
      state.lastDate = null;
      state.roundDetails = null;
      state.roundTimeline = [];
      state.roundCornerTimeline = [];
    },
    aGetRoundSpecialDetailsAction: () => {},
    aGetRoundSpecialDetailsSuccessAction: (state, action) => {
      state.roundDetails = action.payload.details;
      state.roundTimeline = action.payload.timeline;
      state.roundCornerTimeline = action.payload.cornerTimeline;
    },
    aGetRoundSpecialDetailsFailAction: (state) => {
      state.roundDetails = null;
      state.roundTimeline = [];
      state.roundCornerTimeline = [];
    },
    aSetSelectedOddsHistoryRoundSpecialAction: (state, action) => {
      state.selectedMarketOddsHistory = action.payload.marketIds;
    },
    aGetRoundSpecialOddsDetailsAction: () => {},
    aGetRoundSpecialOddsDetailsSuccessAction: (state, action) => {
      state.oddsDetails = action.payload.oddsDetails;
      state.marketsDisplayed = action.payload.marketsDisplayed;
    },
    aGetRoundSpecialOddsDetailsFailAction: () => {},
    aExportRoundSpecialOddsDetailsAction: () => {},
    aExportRoundSpecialOddsDetailsSuccessAction: () => {},
    aExportRoundSpecialOddsDetailsFailAction: () => {},
    aSetRoundSpecialOddsHistory: (state, action) => {
      state.roundSpecialOddsHistoryTemplate = action.payload.roundSpecialOddsHistoryTemplate;
    },
  },
});

export const {
  aGetRoundSpecialRoundsAction,
  aGetRoundSpecialRoundsSuccessAction,
  aGetRoundSpecialRoundsFailAction,
  aClearRoundSpecialsState,
  aGetRoundSpecialDetailsAction,
  aGetRoundSpecialDetailsFailAction,
  aGetRoundSpecialDetailsSuccessAction,
  aSetSelectedOddsHistoryRoundSpecialAction,
  aGetRoundSpecialOddsDetailsAction,
  aGetRoundSpecialOddsDetailsSuccessAction,
  aGetRoundSpecialOddsDetailsFailAction,
  aExportRoundSpecialOddsDetailsAction,
  aExportRoundSpecialOddsDetailsSuccessAction,
  aExportRoundSpecialOddsDetailsFailAction,
  aSetRoundSpecialOddsHistory
} = roundSpecialSlice.actions;

export default roundSpecialSlice.reducer;